angular.module('Main').directive('vIban', ['$q', '$compile', 'BookingService', function ($q, $compile, BookingService) {
    return {
        restrict: "A",
        scope: {},
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {


            ngModel.$asyncValidators.iban = function (modelValue, viewValue) {
                return BookingService.isIbanValid(viewValue).then(
                    function (valid) {
                        if (_.isUndefined(valid.isValid)) {
                            ngModel.$setValidity("vIban", valid);

                            if (!valid && attrs.validIban === true) {
                                return $q.reject();
                            }

                            return true
                        } else {
                            if (valid.isValid && valid.isDE) {
                                ngModel.$setValidity("vIban", valid.isValid);
                                attrs.isDeIban = true;
                                attrs.isValidiban = true;

                            }
                        if (valid.isValid && !valid.isDE) {
                            ngModel.$setValidity("vIban", valid.isValid);
                            attrs.isDeIban = false;
                            attrs.isValidiban = true;
                        }
                        if (!valid.isValid) {
                            ngModel.$setValidity("vIban", valid.isValid);
                            attrs.isDeIban = false;
                            attrs.isValidiban = false;
                        }

                        return valid;
                    }


                    }
                )
            }
        }
    }
}])